(function() {
    // Czekamy aż DOM będzie gotowy
    document.addEventListener('DOMContentLoaded', function () {
        const header = document.querySelector('.header');
        const toggle = document.querySelector('.header__toggle');
        const nav = document.querySelector('.header__nav');
        const overlay = document.querySelector('.header__overlay');
        const closeBtn = document.querySelector('.header__close');
        const body = document.body;

        let scrollPosition = 0;

        function openMenu() {
            scrollPosition = window.scrollY;
            body.style.top = `-${scrollPosition}px`;
            body.classList.add('body--lock');
            toggle.classList.add('is-active');
            nav.classList.add('is-active');
            overlay.classList.add('is-active');
        }

        function closeMenu() {
            body.classList.remove('body--lock');
            body.style.top = '';
            window.scrollTo(0, scrollPosition);
            toggle.classList.remove('is-active');
            nav.classList.remove('is-active');
            overlay.classList.remove('is-active');
        }

        toggle.addEventListener('click', () => {
            nav.classList.contains('is-active') ? closeMenu() : openMenu();
        });

        overlay.addEventListener('click', closeMenu);
        closeBtn.addEventListener('click', closeMenu);

        window.addEventListener('scroll', () => {
            if (window.scrollY > 20) {
                header.classList.add('is-scrolled');
            } else {
                header.classList.remove('is-scrolled');
            }
        });


        // Pobieramy wszystkie przyciski historii cen
        const buttons = document.querySelectorAll('.btn-history');

        buttons.forEach(btn => {
            // Pobieramy przypisany modal
            const modal = document.getElementById(btn.dataset.id);
            if (!modal) return; // jeśli brak modala, pomijamy

            const close = modal.querySelector('.close');

            // Kliknięcie w przycisk otwiera modal
            btn.addEventListener('click', () => {
                modal.style.display = 'block';
            });

            // Kliknięcie w X zamyka modal
            if (close) {
                close.addEventListener('click', () => {
                    modal.style.display = 'none';
                });
            }

            // Kliknięcie poza modal zamyka modal
            window.addEventListener('click', (e) => {
                if (e.target === modal) {
                    modal.style.display = 'none';
                }
            });
        });


        const easeOutElements = document.querySelectorAll('.container.ease-out');
        const fadeInElements = document.querySelectorAll('.fade-in-up');

        const animateOnView = (elements) => {
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('is-visible');
                        observer.unobserve(entry.target); // animacja tylko raz
                    }
                });
            }, { threshold: 0.1 });

            elements.forEach(el => observer.observe(el));
        };

        // Animujemy wszystkie klasy
        animateOnView(easeOutElements);
        animateOnView(fadeInElements);
    });

})();